import { assertArray } from "../../../../utils/assert/index";
import { VehicleGeoposition } from "../../../../../rest/GetVehiclesGeoposition";
import { Store } from "../../../../../flux";
import { names } from "./VehicleGeopositionActions";

export interface VehicleGeopositionStoreState
{
    Vehicles: VehicleGeoposition[];
}

export class VehicleGeopositionStore extends Store<VehicleGeopositionStoreState>
{
    constructor()
    {
        super();
        this.state = this.getDefaultState();

        this.register<VehicleGeoposition[]>(names.SET_VEHICLES, e => this.field({ Vehicles: assertArray(e.payload) }));
        this.register(names.CLEAR, e => this.getDefaultState());
    }

    private getDefaultState(): VehicleGeopositionStoreState
    {
        return { Vehicles: [] };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/flux/VehicleGeopositionStore.ts